import React, { useEffect, useState } from 'react';
import './contact_redesign.css';
import { AppointReq } from '../Functions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import MetaTags from '../meta';
import { tags } from '../Data/metaTags';

// Placeholder Images (Campus/Stalls)
import iitbImg from '../assets/suits.jpg'; // Using existing images as placeholders
import iitmImg from '../assets/suits1.jpg';
import bitsImg from '../assets/suit2.jpg';

// Logos
import iitbLogo from '../assets/logo/iit_b.png';
import bitsLogo from '../assets/logo/bits.png';

// Testimonial avatars (placeholders)
import avatar1 from '../assets/icon/google.png';

const AppointmentPage = () => {
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const notify = () => toast.info("Request received. We will contact you shortly.", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark"
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        
        // Form fields to capture based on new requirements
        const formData = new FormData(e.target);
        const data = {
            id: (new Date().getTime()).toString(),
            name: formData.get('name'),
            collegeName: formData.get('collegeName'),
            city: formData.get('city'),
            role: formData.get('role'),
            expectedEvent: formData.get('expectedEvent'),
            phone: formData.get('mobileNumber'),
            email: "exhibition@campus.com", // Fallback if required by backend
            des: "Campus Exhibition Request"
        };
        
        await AppointReq(data);
        notify();
        setLoad(false);
        e.target.reset();
    };

    return (
        <div className="bg-[#0A0A0B] min-h-screen text-white font-sans pb-20" style={{fontFamily: 'var(--font-body)'}}>
            <MetaTags data={tags.reachus} /> 
            <ToastContainer position="bottom-center" theme="dark" />

            {/* 1. Hero / Campus Presence (Full Height) */}
            <section className="relative min-h-screen flex flex-col justify-center items-center px-4 pt-20 pb-12 overflow-hidden">
                {/* Background overlay/effect */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-[#001427]/20 to-[#0A0A0B] z-0 pointer-events-none"></div>
                
                <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col items-center">
                    <div className="text-center mb-16 animate-fade-in-up">
                        <div className="flex items-center justify-center gap-4 mb-6">
                            <div className="h-[1px] w-16 md:w-24 bg-gradient-to-r from-transparent to-[#D4AF37]"></div>
                            <span className="uppercase tracking-[0.3em] text-[#D4AF37] text-sm md:text-base font-medium">Exclusive Program</span>
                            <div className="h-[1px] w-16 md:w-24 bg-gradient-to-l from-transparent to-[#D4AF37]"></div>
                        </div>
                        <h1 className="text-5xl md:text-7xl mb-6 text-white" style={{fontFamily: 'var(--font-heading)', textShadow: '0 4px 20px rgba(0,0,0,0.5)'}}>
                            Our Campus <span className="text-[#D4AF37]">Presence</span>
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto font-light leading-relaxed">
                            Live Suit Stalls Across the Top IITs & BITS. Bringing bespoke tailoring directly to your campus.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
                        {/* Placeholder Cards with Hover Effects */}
                        <div className="group flex flex-col items-center transform transition-all duration-500 hover:-translate-y-4">
                            <div className="w-full h-80 bg-[#001427] rounded-xl overflow-hidden mb-6 relative shadow-2xl border border-[#1a2b40] group-hover:border-[#D4AF37]/50 transition-colors duration-500">
                                <div className="absolute inset-0 bg-black/40 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                                <img src={iitbImg} alt="IIT Bombay" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" />
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide" style={{fontFamily: 'var(--font-heading)'}}>IIT Bombay</h3>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-3 transition-all duration-500 group-hover:w-16"></div>
                        </div>
                        <div className="group flex flex-col items-center transform transition-all duration-500 hover:-translate-y-4 md:mt-12">
                            <div className="w-full h-80 bg-[#001427] rounded-xl overflow-hidden mb-6 relative shadow-2xl border border-[#1a2b40] group-hover:border-[#D4AF37]/50 transition-colors duration-500">
                                <div className="absolute inset-0 bg-black/40 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                                <img src={iitmImg} alt="IIT Madras" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" />
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide" style={{fontFamily: 'var(--font-heading)'}}>IIT Madras</h3>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-3 transition-all duration-500 group-hover:w-16"></div>
                        </div>
                        <div className="group flex flex-col items-center transform transition-all duration-500 hover:-translate-y-4">
                            <div className="w-full h-80 bg-[#001427] rounded-xl overflow-hidden mb-6 relative shadow-2xl border border-[#1a2b40] group-hover:border-[#D4AF37]/50 transition-colors duration-500">
                                <div className="absolute inset-0 bg-black/40 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                                <img src={bitsImg} alt="BITS Pilani" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" />
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide" style={{fontFamily: 'var(--font-heading)'}}>BITS Pilani</h3>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-3 transition-all duration-500 group-hover:w-16"></div>
                        </div>
                    </div>
                    
                    {/* Scroll Indicator */}
                    <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-50 hidden md:block">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 5v14M19 12l-7 7-7-7"/>
                        </svg>
                    </div>
                </div>
            </section>

            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

            {/* 2. Process Section */}
            <section className="py-12 px-4 max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <div className="flex items-center justify-center gap-4 mb-10">
                        <div className="h-[1px] w-12 bg-[#D4AF37] opacity-50"></div>
                        <h2 className="text-3xl md:text-4xl" style={{fontFamily: 'var(--font-heading)'}}>How Our <span className="text-[#D4AF37]">Campus Suit</span> Program Works</h2>
                        <div className="h-[1px] w-12 bg-[#D4AF37] opacity-50"></div>
                    </div>

                    <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 max-w-4xl mx-auto">
                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4 text-[#D4AF37] text-3xl" style={{fontFamily: 'var(--font-heading)'}}>
                                10+
                            </div>
                            <p className="text-gray-300 text-sm">Premier Institutes</p>
                        </div>
                        
                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>
                        
                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5">
                                    <path d="M3 21h18M5 21V8l7-5 7 5v13M9 21v-5a2 2 0 012-2h2a2 2 0 012 2v5" />
                                </svg>
                            </div>
                            <p className="text-gray-300 text-sm">We setup stall inside campus</p>
                        </div>

                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>

                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5">
                                    <path d="M20 7h-3V4c0-1.1-.9-2-2-2H9C7.9 2 7 2.9 7 4v3H4c-1.1 0-2 .9-2 2v11h20V9c0-1.1-.9-2-2-2zM9 4h6v3H9V4z" />
                                </svg>
                            </div>
                            <p className="text-gray-300 text-sm">Students try & order <span className="text-[#D4AF37]">custom suits</span></p>
                        </div>

                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>

                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5">
                                    <path d="M5 18h14M5 14h14M5 10h14M3 6h18" />
                                </svg>
                            </div>
                            <p className="text-gray-300 text-sm">Delivery before placement/farewell</p>
                        </div>
                    </div>
                </div>

                {/* Logos */}
                <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 mt-12 opacity-50 grayscale">
                    <img src={iitbLogo} alt="IITB" className="h-12 object-contain" />
                    <img src={bitsLogo} alt="BITS" className="h-12 object-contain" />
                    <img src={iitbLogo} alt="IIT" className="h-12 object-contain" />
                    <img src={bitsLogo} alt="BITS" className="h-12 object-contain" />
                    <img src={iitbLogo} alt="IIT" className="h-12 object-contain" />
                    <img src={bitsLogo} alt="BITS" className="h-12 object-contain" />
                </div>
            </section>

            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

            {/* 3. Counters */}
            <section className="py-12 px-4 max-w-7xl mx-auto">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
                    <div>
                        <h3 className="text-4xl md:text-5xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>10+</h3>
                        <p className="text-gray-400 text-sm uppercase tracking-wider">Campuses Covered</p>
                    </div>
                    <div>
                        <h3 className="text-4xl md:text-5xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>5000+</h3>
                        <p className="text-gray-400 text-sm uppercase tracking-wider">Students Served</p>
                    </div>
                    <div>
                        <h3 className="text-4xl md:text-5xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>95<span className="text-2xl">%</span></h3>
                        <p className="text-gray-400 text-sm uppercase tracking-wider">Satisfaction Rate</p>
                    </div>
                    <div>
                        <h3 className="text-4xl md:text-5xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>400+</h3>
                        <p className="text-gray-400 text-sm uppercase tracking-wider">Fitting Calls Per Campus</p>
                    </div>
                    <div>
                        <h3 className="text-4xl md:text-5xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>400+</h3>
                        <p className="text-gray-400 text-sm uppercase tracking-wider">Orders in Single Campus</p>
                    </div>
                </div>
            </section>

            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

            {/* 4. Form & Testimonials */}
            <section className="py-20 px-4 max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                    {/* Left Column: Catch Phrase & Details */}
                    <div className="flex flex-col gap-8 lg:sticky lg:top-24">
                        <div>
                            <div className="flex items-center gap-4 mb-4">
                                <div className="h-[1px] w-12 bg-[#D4AF37]"></div>
                                <span className="uppercase tracking-widest text-[#D4AF37] text-sm font-medium">Join The Network</span>
                            </div>
                            <h2 className="text-4xl md:text-5xl text-white leading-tight mb-6" style={{fontFamily: 'var(--font-heading)'}}>
                                Invite MAVIINCI to <br/><span className="text-[#D4AF37]">Your Campus</span>
                            </h2>
                            <p className="text-gray-400 text-lg leading-relaxed mb-8">
                                Elevate your campus placements and farewells with perfectly tailored, premium suits. Our dedicated team will set up a live fitting stall directly at your college, offering an exclusive and seamless bespoke experience for all students.
                            </p>
                        </div>

                        {/* Testimonials */}
                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl text-white mb-2" style={{fontFamily: 'var(--font-heading)'}}>What Students Say</h3>
                            <div className="bg-[#001427]/50 p-5 rounded-lg border-l-4 border-[#D4AF37] backdrop-blur-sm">
                                <h4 className="text-white font-medium text-lg mb-1">"Best fitting suit I've ever worn!"</h4>
                                <p className="text-gray-400 text-sm">Sagar Jain, IIT Kanpur</p>
                            </div>

                            <div className="bg-[#001427]/50 p-5 rounded-lg border-l-4 border-[#D4AF37] backdrop-blur-sm">
                                <h4 className="text-white font-medium text-lg mb-1">"Placement ke liye perfect tha."</h4>
                                <p className="text-gray-400 text-sm">Ankit Mehra, IIT Bombay</p>
                            </div>

                            <div className="bg-[#001427]/50 p-5 rounded-lg border-l-4 border-[#D4AF37] backdrop-blur-sm">
                                <h4 className="text-white font-medium text-lg mb-1">"Bikul professional experience!"</h4>
                                <p className="text-gray-400 text-sm">Tanvi Singh, BITS Pilani</p>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Form */}
                    <div className="bg-[#001427] p-8 md:p-10 rounded-xl shadow-2xl border border-gray-800 relative overflow-hidden">
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
                        
                        <div className="mb-8">
                            <h3 className="text-2xl text-white mb-2" style={{fontFamily: 'var(--font-heading)'}}>Get in Touch</h3>
                            <p className="text-gray-400 text-sm">Fill out the form below and our campus relations team will contact you shortly.</p>
                        </div>

                        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                            <div className="group">
                                <input 
                                    type="text" 
                                    name="name" 
                                    placeholder="Your Name" 
                                    required 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600"
                                />
                            </div>
                            
                            <div className="group">
                                <input 
                                    type="text" 
                                    name="collegeName" 
                                    placeholder="College / Institute Name" 
                                    required 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600"
                                />
                            </div>
                            
                            <div className="group">
                                <input 
                                    type="text" 
                                    name="city" 
                                    placeholder="City" 
                                    required 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600"
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="group relative">
                                    <select 
                                        name="role" 
                                        required
                                        defaultValue=""
                                        className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all appearance-none cursor-pointer group-hover:border-gray-600"
                                    >
                                        <option value="" disabled hidden>Your Role</option>
                                        <option value="Student Union">Student Union</option>
                                        <option value="Admin">Admin</option>
                                    </select>
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">▼</div>
                                </div>

                                <div className="group relative">
                                    <select 
                                        name="expectedEvent" 
                                        required
                                        defaultValue=""
                                        className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all appearance-none cursor-pointer group-hover:border-gray-600"
                                    >
                                        <option value="" disabled hidden>Expected Event</option>
                                        <option value="Placement">Placement</option>
                                        <option value="Farewell">Farewell</option>
                                    </select>
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">▼</div>
                                </div>
                            </div>
                            
                            <div className="group">
                                <input 
                                    type="tel" 
                                    name="mobileNumber" 
                                    placeholder="WhatsApp / Mobile Number" 
                                    required 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600"
                                />
                            </div>
                            
                            <button 
                                type="submit" 
                                disabled={load}
                                className="w-full bg-[#D4AF37] text-black font-bold py-4 mt-4 rounded-lg hover:bg-[#b08d4a] transition-all disabled:opacity-70 transform hover:-translate-y-1 hover:shadow-lg shadow-[#D4AF37]/20 text-lg"
                            >
                                {load ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AppointmentPage;